module.exports = __webpack_public_path__ + "static/screen-jet2holidays.d8ba49e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/screen-jet2holidays.jpg
// module id = 415
// module chunks = 114276838955818